import { NAV_PATHS } from 'src/paths';
import type { CareerHubLanguage } from 'src/types';

const getQueryParams = (queryParams?: Record<string, string>): string => {
  if (!queryParams) {
    return '';
  }

  return Object.entries(queryParams).reduce(
    (acc, [key, value]) =>
      acc ? `${acc}&${key}=${value}` : `?${key}=${value}`,
    '',
  );
};

interface getPagePathsProps {
  language: CareerHubLanguage;
  queryParams?: Record<string, string>;
  pathParams?: Record<string, string>;
}

const replacePathParams = (
  url: string,
  pathParams?: Record<string, string>,
) => {
  if (!pathParams) return url;
  return Object.entries(pathParams).reduce((acc, [key, value]) => {
    const regex = new RegExp(`:${key}`, 'g');
    return acc.replace(regex, value);
  }, url);
};

export const getPagePaths = ({
  language,
  queryParams,
  pathParams,
}: getPagePathsProps) => {
  let languagePrefixPath = '';

  if (language.startsWith('id')) {
    languagePrefixPath = '/id';
  } else if (language.startsWith('th')) {
    languagePrefixPath = '/th';
  } else if (language.startsWith('zh')) {
    languagePrefixPath = '/zh';
  }

  return {
    CommunityHome: `${languagePrefixPath}${replacePathParams(
      NAV_PATHS.communityHome,
      pathParams,
    )}${getQueryParams(queryParams)}`,
    CommunityGroups: `${languagePrefixPath}${replacePathParams(
      NAV_PATHS.communityGroups,
      pathParams,
    )}${getQueryParams(queryParams)}`,
    CommunityThreads: `${languagePrefixPath}${replacePathParams(
      NAV_PATHS.communityThreads,
      pathParams,
    )}${getQueryParams(queryParams)}`,
    CommunityThreadDetail: `${languagePrefixPath}${replacePathParams(
      NAV_PATHS.communityThreadDetail,
      pathParams,
    )}${getQueryParams(queryParams)}`,
    communityGroupsDetails: `${languagePrefixPath}${replacePathParams(
      NAV_PATHS.communityGroupsDetails,
      pathParams,
    )}${getQueryParams(queryParams)}`,
  } as const;
};
